/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// This function will grab all input values from a form and return an object
function serialize(form) {
    // console.log(form.elements);
    if (!form || form.nodeName !== "FORM") {
        return;
    }

    var i, j, result = {};
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
        if (form.elements[i].name === "") {
            continue;
        }

        switch (form.elements[i].nodeName) {
            case 'INPUT':
                switch (form.elements[i].type) {
                    case 'text':
                    case 'hidden':
                    case 'password':
                    case 'button':
                    case 'reset':
                    case 'submit':
                        result[form.elements[i].name] = form.elements[i].value;
                        break;
                    case 'radio':
                        if (form.elements[i].checked) {
                            result[form.elements[i].name] = form.elements[i].value;
                        }
                        break;
                    case 'checkbox':
                            result[form.elements[i].name] = form.elements[i].checked;
                        break;
                    default:
                        result[form.elements[i].name] = form.elements[i].value;
                        break;
                }
                break;
            case 'file':
                break;
            case 'SELECT':
                switch (form.elements[i].type) {
                    case 'select-one':
                        result[form.elements[i].name] = form.elements[i].value;
                        break;
                    case 'select-multiple':
                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                            if (form.elements[i].options[j].selected) {
                                result[form.elements[i].name] = form.elements[i].options[j].value;
                            }
                        }
                        break;
                }
            default:
                result[form.elements[i].name] = form.elements[i].value;
                break;

        }
    }
    return result;
}

function set_loading(btn, color){
    color = typeof color !== 'undefined' ? color : 'text-white';

    var spinner = document.createElement("div");
    spinner.setAttribute("class", "spinner-border " + color);
    spinner.setAttribute("role", "status");

    var spinner_span = document.createElement("span");
    spinner_span.setAttribute("class", "visually-hidden");
    spinner_span.innerHTML = "Loading...";

    btn.innerHTML = "";
    spinner.appendChild(spinner_span);
    btn.appendChild(spinner);
}

function getAllCookies() {
    var cookies = document.cookie.split(';');
    var cookieObject = {};

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var parts = cookie.split('=');
        var name = parts[0].trim();
        var value = parts[1] ? decodeURIComponent(parts[1].trim()) : "";

        cookieObject[name] = value;
    }

    return cookieObject;
}

function getCookie(name) {
    var allCookies = getAllCookies();
    return allCookies[name] || null;
}

function setCookie(name, value, expireInMinutes, updateExisting = false) {
    // Transform the name
    name = name.toLowerCase().replace(/ /g, '_');

    // Calculate the expiration time
    const currentDate = new Date();
    currentDate.setTime(currentDate.getTime() + expireInMinutes * 60 * 1000);
    const expires = "expires=" + currentDate.toUTCString();

    // Check if the cookie exists
    var existingValue = getCookie(name);
    if (existingValue === null || updateExisting) {
        // Cookie doesn't exist, or updateExisting is true, so set the cookie
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }
}

function deleteCookie(name) {
    // Set the expiration date to a date in the past (1st January 1970)
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

window.onload = function() {
  document.body.addEventListener("click", function (event) {
    if (event.target.getAttribute('data-action') === "close-modal") {
      const modal = event.target.closest('.modal');
      if (modal) {
        modal.setAttribute('aria-hidden', 'true');
      }
    }
  });
};

function addToCart(variantId, quantity, properties = null) {
    let data = {
        id: variantId,
        quantity: quantity
    }

    if (properties) {
      data.properties = properties;
    }
  
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    .then(response => response.json());
}

function addProductsToCart (variantIds, quantity, properties = null) {
  variantIds.reduce((promise, variantId) => {
    return promise.then(() => addToCart(variantId, quantity, properties));
  }, Promise.resolve())
  .then(() => {
    console.log('All products added to cart');
  })
  .catch((error) => {
    console.error('Error adding products to cart:', error);
  });
}

// Function to fetch product details
function fetchProductDetails(productHandle) {
  return fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .catch(error => console.error('Error fetching product details:', error));
}

// Function to check if the product is in any of the specified collections
function isProductInCollections(product, tags) {
  // Check if the product's collections include any of the desired collection handles
  return tags.some(tag => product.tags.includes(tag));
}

// Function to check and update the cart
function checkAndUpdateCart() {
  const FREE_PRODUCT_VARIANT_IDS = [
    40230025363554, // 1209RL
  ];
  const COLLECTION_TAGS = [
    'GEN-Z',
    'Gen-Z Sets',
    'single-tattoo-inks',
    'Single Artist Series Ink',
    'INTENZE Color Ink Sets',
    'All Black & Grey Ink Sets',
    'Pro Nouveau'
  ];
  const REQUIRED_QUANTITY = 4;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasAnyFreeProduct = FREE_PRODUCT_VARIANT_IDS.some(variantId =>
        cart.items.some(item => item.variant_id === variantId)
      );

      if (!hasAnyFreeProduct) {
        const promises = cart.items.map(item => {
          return fetchProductDetails(item.handle).then(productDetails => {
            return {
              item: item,
              inCollection: isProductInCollections(productDetails, COLLECTION_TAGS)
            };
          });
        });

        Promise.all(promises).then(results => {
          let totalItems = results.reduce((total, result) => {
            if (result.inCollection) {
              return total + result.item.quantity;
            }
            return total;
          }, 0);

          if (totalItems >= REQUIRED_QUANTITY) {
            addProductsToCart(FREE_PRODUCT_VARIANT_IDS, 1, {
              discount: 'exclusivePromo'
            });
          }
        });
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// document.addEventListener("DOMContentLoaded", function() {
//   // Listen for Shopify's cart updated event
//   document.addEventListener('theme:loading:end', checkAndUpdateCart);
//   checkAndUpdateCart();
// });